import {
    ADDED_TO_BASKET_MODAL_ID,
    Position,
    PRODUCT_NOTIFY_ME,
    PRODUCT_STORE_MENU_ID,
} from '@headless-workspace/config';
import { SideMenuModal } from '@headless-workspace/core-ui';
import { PropsWithLocale } from '@headless-workspace/glow-ds';
import {
    ActionStatus,
    NotifyMeModal,
    ProductDetailInfoModal,
    ProductDetailInfoModalContext,
    StoresDeliveryContainer,
} from '../../../../../client';
import { BasketProductValue, VipBrandsValue } from '../../../../../server';
import { ProductAddToBasketModal } from '../../../modals';

export type OpenModalParams = PropsWithLocale &
    (
        | {
              actionStatus: ActionStatus.AddToBasketCondition;
              productAddedToBasket: BasketProductValue;
              vipBrands: VipBrandsValue;
          }
        | {
              actionStatus: ActionStatus.NotifyMeCondition;
              productIds: string[];
          }
        | {
              actionStatus: ActionStatus.ChooseStoreCondition | ActionStatus.ChangeStoreCondition;
              storeModalInfo: {
                  title: string;
                  closeButtonLabel: string;
              };
          }
    );

type CreateModalOptionsReturnType = { modalId: string; modal: SideMenuModal };

const createModalOptions = (params: OpenModalParams): CreateModalOptionsReturnType | undefined => {
    const basketModalClasses = 'w-modalAddToCartMobile tablet:w-modalAddToCartTablet m-auto mt-1.25 tablet:mt-1';

    switch (params.actionStatus) {
        case ActionStatus.AddToBasketCondition:
            return {
                modalId: ADDED_TO_BASKET_MODAL_ID,
                modal: SideMenuModal(
                    Position.None,
                    {
                        default: (
                            <ProductAddToBasketModal
                                locale={params.locale}
                                product={params.productAddedToBasket}
                                vipBrands={params.vipBrands}
                            />
                        ),
                    },
                    basketModalClasses,
                ),
            };

        case ActionStatus.NotifyMeCondition:
            return {
                modalId: PRODUCT_NOTIFY_ME,
                modal: SideMenuModal(Position.Right, {
                    default: <NotifyMeModal locale={params.locale} productIds={params.productIds} />,
                }),
            };

        case ActionStatus.ChooseStoreCondition:
        case ActionStatus.ChangeStoreCondition:
            return {
                modalId: PRODUCT_STORE_MENU_ID,
                modal: SideMenuModal(Position.Right, {
                    default: (
                        <ProductDetailInfoModal
                            title={params.storeModalInfo.title}
                            closeButtonLabel={params.storeModalInfo.closeButtonLabel}
                            renderInformation={<StoresDeliveryContainer locale={params.locale} />}
                            context={ProductDetailInfoModalContext.storeSelection}
                            isSidePanelDeliveryZone={true}
                            productModalId={PRODUCT_STORE_MENU_ID}
                        />
                    ),
                }),
            };
        default:
            return undefined;
    }
};

export const ProductModalHelpers = {
    createModalOptions,
};
